<template>
  <div class="sr-table" :class="{ noData: data && data.length == 0 }">
    <div v-if="config.subTitle" class="sub-title">
      <SrSubTitle :title="config.subTitle"></SrSubTitle>
    </div>
    <el-table
      ref="SrTable"
      @select-all="selectAll"
      @select="select"
      @selection-change="selectChange"
      @row-click="rowClick"
      @row-dblclick="rowDblclick"
      @sort-change="sortChange"
      :highlight-current-row="
        config.highlightCurrentRow || config['highlight-current-row']
      "
      :data="tableData"
      :height="config.height"
      :max-height="config.maxHeight || config['max-height']"
      :show-summary="config.showSummary || config['show-summary']"
      :sum-text="config.sumText || config['sum-text'] || '合计（万元）'"
      :row-key="config.rowKey || config['row-key'] || 'id'"
      :lazy="config.lazy || true"
      :default-expand-all="
        config.expandAll || config['default-expand-all'] || false
      "
      :load="config.load || (() => {})"
      :tree-props="
        config.treeProps ||
        config['tree-props'] || {
          children: 'children',
          hasChildren: 'hasChildren',
        }
      "
      :row-class-name="config.rowClassName || config['row-class-name']"
      :cell-class-name="config.cellClassName || config['cell-class-name']"
      :tooltip-effect="config['tooltip-effect'] || 'light'"
      :tooltip-placement="config['tooltip-placement'] || 'top-start'"
      title=""
      v-bind="config"
      v-on="$listeners"
    >
      <el-table-column
        v-if="config.selectionConfig && config.selectionConfig.display"
        align="left"
        type="selection"
        :reserve-selection="true"
        :width="config.selectionConfig.width || 50"
        v-bind="config.selectionConfig"
      ></el-table-column>
      <el-table-column
        type="index"
        :width="config.indexConfig.width || 52"
        v-bind="config.indexConfig"
        v-if="config.indexConfig && config.indexConfig.display"
      ></el-table-column>
      <el-table-column
        type="expand"
        v-if="config.expandConfig && config.expandConfig.display"
      >
        <template slot-scope="scope">
          <slot name="expand" :scope="{ row: scope.row }"></slot>
        </template>
      </el-table-column>
      <el-table-column label v-if="!config.header.length"></el-table-column>
      <el-table-column
        :min-width="item.minWidth || item['min-width']"
        v-for="item in config.header"
        :key="item.prop"
        v-bind="item"
        :class-name="item.activable?'activable':''"
      >
        <div slot-scope="scope" @click.stop="callFn(item, scope.row, item.name)">
          <slot
            name="cellSlot"
            v-if="item.cellSlot"
            :scope="{
              row: scope.row,
              item: item,
              index: item.index,
            }"
          ></slot>
          <slot
            :name="item.slotName"
            v-else-if="item.slotName"
            :scope="{
              row: scope.row,
              item: item,
              index: item.index,
            }"
          ></slot>
          <div v-else-if="item.type == 'image'">
            <uploadImgView :view-data="scope.row[item.prop]" v-bind="item" v-if="scope.row[item.prop]"/>
            <span v-else>{{ isZero(scope.row[item.prop]) }}</span>
          </div>
          <div v-else-if="item.dataList" :class="item.className">
            {{ getValue(item, scope.row[item.prop]) }}
          </div>
          <span v-else :class="item.className">
            {{ isZero(scope.row[item.prop]) }}
          </span>
        </div>
        <template slot="header" v-if="item.slotHeaderBox">
          <div class="slotbox" style="height: 100%">
            {{ item.label }}
            <el-popover
              ref="popover1"
              placement="top"
              trigger="hover"
              v-if="config.operateConfig.showHeaderSetting"
              content="表头设置"
            >
              <div slot="reference" class="header-set" @click="settingHeader" :style="`right: ${exportIndex ? 40 : 0}px`">
                <img :src="setIcon"/>
              </div>
            </el-popover>
            <el-popover
              ref="popover2"
              placement="top"
              trigger="hover"
              v-if="!config.operateConfig.hideHeaderexport"
              content="导出"
            >
              <div v-if="exportIndex" slot="reference" class="header-set" @click="config.operateConfig.export">
                <img :src="exportIcon" style="width: 20px; height: 20px;"/>
              </div>
            </el-popover>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="config.operateConfig && config.operateConfig.display"
        :width="config.operateConfig.width || 156"
        v-bind="config.operateConfig"
        class="operate"
      >
        <template slot="header">
          <div style="height: 100%">
            {{ config.operateConfig.label }}
            <el-popover
              ref="popover1"
              placement="top"
              trigger="hover"
              v-if="config.operateConfig.showHeaderSetting"
              content="表头设置"
            >
              <div slot="reference" class="header-set" @click="settingHeader" :style="`right: ${exportIndex ? 40 : 0}px`">
                <img :src="setIcon"/>
              </div>
            </el-popover>
            <el-popover
              ref="popover2"
              placement="top"
              trigger="hover"
              v-if="!config.operateConfig.hideHeaderexport"
              content="导出"
            >
              <div v-if="exportIndex" slot="reference" class="header-set" @click="config.operateConfig.export">
                <img :src="exportIcon" style="width: 20px; height: 20px;"/>
              </div>
            </el-popover>
          </div>
        </template>
        <div class="operate_btns" slot-scope="scope">
          <template
            v-for="(item, index) in scope.row.btns.slice(
              0,
              scope.row.btns.length <= 3 ? 3 : 2
            )"
          >
            <el-button
              :key="index"
              size="medium"
              :type="item.type || 'text'"
              @click="
                () => {
                  scope.row.path(scope.row, item);
                }
              "
              v-if="item.btnName"
              >{{ item.name }}</el-button
            >
            <el-button
              :key="index"
              :type="item.type"
              size="medium"
              @click="callFn(item, scope.row, item.name)"
              v-else
              >{{ item.name }}</el-button
            >
          </template>

          <el-popover
            placement="bottom-end"
            width="auto"
            trigger="hover"
            class="more_popover"
            popper-class="sr_table_popover"
            v-if="scope.row.btns && scope.row.btns.length > 3"
          >
            <div class="popover_container">
              <ul class="infinite-list" style="overflow: auto">
                <template v-for="(item, index) in scope.row.btns.slice(2)">
                  <li
                    :key="index"
                    class="infinite-list-item"
                    @click="
                      () => {
                        scope.row.path(scope.row, item);
                      }
                    "
                    v-if="item.btnName"
                  >
                    {{ item.name }}
                  </li>
                  <li
                    :key="index"
                    class="infinite-list-item"
                    @click.stop="callFn(item, scope.row, item.name)"
                    v-else
                  >
                    {{ item.name }}
                  </li>
                </template>
              </ul>
            </div>
            <el-button
              @click.stop
              class="more_btns"
              slot="reference"
              type="text"
            >
              更多
            </el-button>
          </el-popover>
        </div>
      </el-table-column>
      <el-table-column
        v-if="config.slotOperateConfig && config.slotOperateConfig.display"
        :width="config.slotOperateConfig.width || 156"
        v-bind="config.slotOperateConfig"
        class="operate"
      >
        <template slot="header">
          <div style="height: 100%">
            {{ config.slotOperateConfig.label }}
          </div>
        </template>
        <div class="operate_btns" slot-scope="scope">
          <template v-for="(index, name) in $scopedSlots">
            <slot :name="name" v-bind="scope.row"></slot>
          </template>
        </div>
      </el-table-column>
      <slot name="empty" slot="empty">
        <div class="table_empty">
          <img :src="emptyImg" class="empty_img" />
          <span class="empty_null">
            {{
              (config.emptyConfig && config.emptyConfig.emptyNull) || "暂无内容"
            }}
          </span>
          <div
            class="empty_tip"
            v-if="config.emptyConfig && config.emptyConfig.emptyTip"
          >
            {{ config.emptyConfig.emptyTip }}
            <span class="empty_btn" @click="emptyClick">{{
              config.emptyConfig.emptyBtn
            }}</span>
          </div>
        </div>
      </slot>
    </el-table>
    <div class="sr_table_bottom">
      <div>
        <slot name="leftBottomSlot"></slot>
      </div>
      <el-pagination
        class="pagination"
        v-if="page.total > (page.minSize || 10)"
        @size-change="handleSizeChange"
        @current-change="handleChange"
        :current-page="page.pageNum || page['current-page'] || 1"
        :layout="page.layout || 'total, sizes, prev, pager, next, jumper'"
        :total="page.total"
        :page-size="page.pageSize || page['page-size'] || 10"
        :page-sizes="page.pageSizes || page['page-sizes'] || [10, 20, 30]"
        v-bind="page"
      ></el-pagination>
    </div>
    <SrSettingTable
      :data="config.operateConfig.allTableHeader"
      @close="() => (dialogVisible = false)"
      :dialogVisible="dialogVisible"
      @saveHeaderList="saveHeaderList"
      v-if="
        config.operateConfig &&
        config.operateConfig.allTableHeader &&
        config.operateConfig.allTableHeader.length &&
        dialogVisible
      "
    ></SrSettingTable>
  </div>
</template>

<script>
import uploadImgView from "../SrView/uploadImgView.vue"
import emptyImg from "./empty.png";
import utils from "../SrUtils/index.js";
export default {
  name: "SrTable",
  components: {
    uploadImgView
  },
  props: {
    enums: Object,
    data: {
      type: Array,
      default() {
        return [];
      },
    },
    page: {
      type: Object,
      default() {
        return {
          total: 0,
          pageSize: 5,
          pageSizes: [5, 10, 20, 30],
          pageNum: 1,
        };
      },
    },
    config: {
      type: Object,
      default() {
        return {};
      },
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      dialogVisible: false,
      emptyImg: emptyImg,
      utils: utils,
      setIcon: require('../theme-chalk/src/images/icon-set@2x.png'),
      exportIcon: require('../theme-chalk/src/images/icon-export@2x.png'),
    };
  },
  computed: {
    exportIndex() {
      return (
        this.config.operateConfig.export &&
        this.utils.checkCodeInArr(
          this.config.operateConfig.exportPermissionCode
        )
      );
    },
    tableData: {
      get: function () {
        let tableData = this.data.map((row) => {
          row.btns = [];
          if (this.config.innerBtn && this.config.innerBtn.length) {
            this.config.innerBtn.forEach((item) => {
              if (
                this.isShowBtn(item, row) &&
                this.utils.checkCodeInArr(item.permissionCode)
              ) {
                row.btns.push(item);
              }
            });
          }

          if (row.operationBtns && row.operationBtns.length) {
            row.operationBtns.forEach((item) => {
              if (item.btnName) {
                row.btns.push({ ...item, name: item.btnName });
              }
            });
          }
          return row;
        });
        return tableData;
      },
      set: function (val) {},
    },
  },
  mounted() {
  },
  methods: {
    getValue(item, val) {
      let result = val
      let options = (this.enums && this.enums[item.dataList]) || utils.dictionary.getDict(item.dataList)
      if (options && options.length>0) {
        for (let i = 0, len = options.length; i < len; i++) {
          if (options[i]['dataValue'] == val) {
            result = options[i]['dataName']
            break
          }
        }
      }
      return this.isZero(result)
    },
    isZero(val) {
      // 判断数据是不是有0的情况
      if (val === 0 || val === "0") {
        return val;
      } else {
        return val || "-";
      }
    },
    //操作事件
    callFn(item, row, name, index) {
      if (item.method && item.method.constructor == Function) {
        // 兼容以前，扩展传入fn方式
        item.method(item, row, name, index);
        return;
      }
      let sum = 0;
      let obj = this.getDeepMethod(this.$parent, item.method, sum, 10);
      if (obj.parent && obj.method) {
        obj.method.call(obj.parent, row, name, index, item);
      }
    },
    saveHeaderList(data) {
      this.dialogVisible = false;
      this.config.operateConfig.saveHeaderList &&
        this.config.operateConfig.saveHeaderList(data);
    },
    settingHeader() {
      this.dialogVisible = true;
    },
    // 递归找method
    getDeepMethod(parent, method, sum, limit) {
      sum++;
      if (!parent) {
        return {};
      } else if (sum == limit) {
        return {};
      } else if (parent[method]) {
        return {
          parent,
          method: parent[method],
        };
      } else {
        return this.getDeepMethod(parent.$parent, method);
      }
    },
    isShowBtn(item, row) {
      // let role = this.roleBtn(item.code || "");
      let field = true;
      let arr =
        item.value == undefined
          ? []
          : item.value.constructor == Array
          ? item.value
          : item.value
          ? [item.value]
          : [];
      if (item.reverse) {
        // 是否反向判断
        field = false;
        arr.map((res) => {
          if (row[item.field] == res) {
            // 找到一个
            field = true;
          }
        });
      } else {
        arr.map((res) => {
          if (row[item.field] == res) {
            // 找到一个
            field = false;
          }
        });
      }
      let validate = true;
      if (item.validate) {
        // 自定义校验方法
        validate = item.validate(item, row);
      }
      return (!item.field || field) && validate;
    },
    //下一页
    handleChange(page) {
      this.$emit("pageChanged", page);
    },
    // 分页大小
    handleSizeChange(size) {
      this.$emit("sizeChanged", size);
    },
    // 多选操作
    selectChange() {
      this.$emit("selected", ...arguments);
    },
    //当用户手动勾选数据行的 Checkbox 时触发的事件
    select() {
      this.$emit("select", ...arguments);
    },
    // 单行点击事件
    rowClick() {
      this.$emit("clickRow", ...arguments);
    },
    // 双击事件
    rowDblclick() {
      this.$emit("rowDblclick", ...arguments);
    },
    // 点击排序事件
    sortChange(column) {
      column.configdata = this.config.header;
      this.$emit("sortChange", column);
    },
    // 点击全选框
    selectAll(selection) {
      this.$emit("selectAll", ...arguments);
    },
    emptyClick() {
      this.$emit("emptyClick");
    },
    // 解决树级table删除最后一个子级不刷新的问题
    clearLazyTreeNodeMap(pid) {
      this.$set(this.$refs.SrTable.store.states.lazyTreeNodeMap, pid, []);
    },
    // 默认选中
    toggleRowSelection(data) {
      console.log("默认选中数据", data);
      this.$refs.SrTable.clearSelection();
      // this.$nextTick(() => {
      data.forEach((item) => {
        this.$refs.SrTable.toggleRowSelection(item, true);
      });
      // })
    },
  },
};
</script>



// WEBPACK FOOTER //
// packages/SrTable/index.vue